import __request__ from "routing/request";
export function administration(JSONbody, requestOptions) {
  return __request__("POST", "/sidecar/administration", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setAction(JSONbody, requestOptions) {
  return __request__("PUT", "/sidecar/administration/action", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
